/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TimeseriesSourcesSinks } from "./TimeseriesSourcesSinks";
import {
  TimeseriesSourcesSinksFromJSON,
  TimeseriesSourcesSinksFromJSONTyped,
  TimeseriesSourcesSinksToJSON,
  TimeseriesSourcesSinksToJSONTyped,
} from "./TimeseriesSourcesSinks";

/**
 *
 * @export
 * @interface PaginatedTimeseriesSourcesSinksList
 */
export interface PaginatedTimeseriesSourcesSinksList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TimeseriesSourcesSinks>;
}

/**
 * Check if a given object implements the PaginatedTimeseriesSourcesSinksList interface.
 */
export function instanceOfPaginatedTimeseriesSourcesSinksList(
  value: object
): value is PaginatedTimeseriesSourcesSinksList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTimeseriesSourcesSinksListFromJSON(
  json: any
): PaginatedTimeseriesSourcesSinksList {
  return PaginatedTimeseriesSourcesSinksListFromJSONTyped(json, false);
}

export function PaginatedTimeseriesSourcesSinksListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTimeseriesSourcesSinksList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TimeseriesSourcesSinksFromJSON),
  };
}

export function PaginatedTimeseriesSourcesSinksListToJSON(
  json: any
): PaginatedTimeseriesSourcesSinksList {
  return PaginatedTimeseriesSourcesSinksListToJSONTyped(json, false);
}

export function PaginatedTimeseriesSourcesSinksListToJSONTyped(
  value?: PaginatedTimeseriesSourcesSinksList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TimeseriesSourcesSinksToJSON),
  };
}
